export default __webpack_public_path__ + "img/bg_labels-7dde92f7a290dbc8fcdfbe70b31be674.png";